module.exports = __webpack_public_path__ + "img/home_gmap_sm.d2fcc2ca.png";